<template>
  <BaseWorkPageLayout :title="$t('global.invoicing')" icon="euro-sign">
    <template v-if="$route.name === 'work_form_invoicing_route'" #cta>
      <BaseDropDownMenu
        :title="$t('button.add')"
        icon="plus"
        size="small"
        show-icon-before
        :show-icon-after="false"
        :options="addOptions"
      />
    </template>
    <template #default>
      <router-view></router-view>
    </template>
  </BaseWorkPageLayout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TheWorkInvoicingRouter',
  computed: {
    ...mapGetters({ settings: 'settings/getSystemSettings' }),
    // The document types the system settings enable.
    addOptions() {
      const available = Object.values(
        this.settings?.invoicing?.available_docs ?? {}
      )
      return [
        ['INV', 'work_form_invoice_new_route', 'global.invoice'],
        ['PO', 'work_form_purchase_order_new_route', 'global.purchase_order'],
        ['QUO', 'work_form_quote_new_route', 'global.quote'],
        ['CN', 'work_form_credit_note_new_route', 'global.credit_note']
      ].map(([docType, routeName, label]) => ({
        label: this.$t(label),
        icon: 'file-plus',
        gate: available.includes(docType) && this.$can('manage_invoicing'),
        action: () => this.$router.push({ name: routeName })
      }))
    }
  }
}
</script>
